import {asJsonOrThrow, asStringOrThrow} from '@shared/lib/type_utils';

import {apiCall} from '@src/lib/api';

function loadAccountData(): {id: string; key: string} | undefined {
  const accountDataStr = localStorage.getItem('account');
  if (accountDataStr === null) {
    return undefined;
  }
  try {
    const accountData = asJsonOrThrow(accountDataStr);
    const id = asStringOrThrow(accountData['id']);
    const key = asStringOrThrow(accountData['key']);
    return {id, key};
  } catch {
    console.error(`Failure to parse account data: ${accountDataStr}`);
  }
  return undefined;
}

function saveAccountData(data: {id: string; key: string}): void {
  localStorage.setItem('account', JSON.stringify(data));
}

export async function auth(): Promise<void> {
  let accountData = loadAccountData();
  if (!accountData) {
    accountData = await apiCall('POST /create-account', {});
    saveAccountData(accountData);
  }
  await apiCall('POST /auth-account', accountData);
}
